import { j as w } from "../../jsx-runtime-B6kdoens.js";
import { useRef as R, useEffect as i } from "react";
import { c as A } from "../../index-CROKJrb5.js";
import { c as E, f as I } from "../../create-component-CBAeEoQ6.js";
import { u as o } from "../../use-sync-atom-value-CDr7vapO.js";
import { createTabsState as q, TabsContext as y, useTabsState as z } from "./TabsState/index.js";
import { w as D } from "../../atom-provider-B3P183Tj.js";
import { u as N } from "../../use-unique-id-BA9hSqap.js";
import { b as P } from "../../react-B_GApDuV.js";
const U = A({}), K = D(
  E(
    "Tabs",
    I(
      ({
        active: c,
        as: u,
        children: p,
        className: b,
        defaultActive: s,
        id: n,
        onActiveChange: t,
        size: T,
        ...d
      }, x) => {
        const S = u || "div", r = N("tabs", n), m = R(!1), { activeAtom: a, idAtom: j, sizeAtom: l } = z(), [e, f] = P(a);
        return o(a, c), o(j, r), o(l, T), i(() => {
          s && !m.current && (f(s), m.current = !0);
        }, [s, f]), i(() => {
          t == null || t(e);
        }, [e, t]), /* @__PURE__ */ w.jsx(
          S,
          {
            ref: x,
            className: U({ className: b }),
            id: r,
            ...d,
            children: p
          }
        );
      }
    )
  ),
  y,
  q
);
export {
  K as Tabs
};
//# sourceMappingURL=index.js.map
